import { HandlerResponse, postRequest } from "./api";
import { API_URL } from "./Environment";

export const createComplaintsAPI = async(payload) => {
    return postRequest(`${API_URL}complaint/create-complaint`,payload)
       .then((resp) => resp);
 }